export default __webpack_public_path__ + "images/de010e1c561cfbee95a852ac3c023c53-hi-friend-es.svg";